import axios from 'axios/index';

/*
    同一个请求同时请求，未完成时取消异步请求
 */
const pending = []; // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
const cancelToken = axios.CancelToken;
const removePending = config => {
  for (const p in pending) {
    if (pending[p].u === config.url + '&' + config.method) {
      // 当当前请求在数组中存在时执行函数体
      pending[p].f(); // 执行取消操作
      pending.splice(p, 1); // 把这条记录从数组中移除
    }
  }
};

/**
 * 收集相同请求，用于取消拦截
 * @param config
 * @returns {*}
 */
export const cancelAxios = config => {
  const { params = {} } = config;
  // 是否需要取消重复的请求，默认是不需要，只有在tab选项卡场景下，频繁调用ajax 时候： needCancelAxios = true
  const { needCancelAxios = false } = params;
  if (needCancelAxios) {
    removePending(config); // 在一个ajax发送前执行一下取消操作
    config.cancelToken = new cancelToken(c => {
      console.log('config===', config.url);
      // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      pending.push({ u: config.url + '&' + config.method, f: c });
    });
  }
  return config;
};

export default cancelAxios;
